import { getServiceIcon } from '@/modules/onboarding/integrations-setup/helpers/data';

import { IntegrationIconUrl } from '../types/entity-integration';
import { IntegrationServices } from '../types/integrations';

/**
 * Maps integration service to its icon path.
 * Centralized icon mapping used across the application.
 */
export const getIntegrationIcon = (service: IntegrationServices): IntegrationIconUrl => {
  return getServiceIcon(service);
};

/**
 * Gets the display name for an integration service.
 */
export const getIntegrationDisplayName = (service: IntegrationServices): string => {
  return service; // IntegrationServices enum values are already display names
};
